module.exports = "https://r.zoocdn.com/_next/static/images/smart-new-homes-logo-c14470407e5d3add0b92db4caece765a.png";